<template>
  <div class="professional-field">
    <div class="section-title">
      <span class="line"></span>
      <h2>获奖公告</h2>
      <span class="line"></span>
    </div>
    <div class="swiper-container">
      <div class="custom-arrow left" @click="toPrev">
        <i class="el-icon-arrow-left"></i>
      </div>
      
      <el-carousel 
        ref="carousel" 
        :autoplay="false" 
        arrow="always" 
        height="820px" 
        direction="horizontal"
        :loop="false"
        indicator-position="none"
      >
        <el-carousel-item v-for="(page, idx) in pageList" :key="idx">
          <div class="page-content">
            <div class="card-row">
              <div @click="toItemFn(item)" class="card-item" v-for="(item, i) in page.row1" :key="i">
                <div class="card-img">
                  <img 
                    :src="`${$baseUrl}/evaluation/api/attachment/preview/${item.coverImageId}`"
                    alt
                    loading="lazy"
                  />
                </div>
                <div class="card-content">
                  <div class="title-line"></div>
                  <h4 class="card-title">{{ item.title }}</h4>
                  <p class="card-desc">{{ item.content }}</p>
                </div>
              </div>
            </div>
            <div class="card-row">
              <div @click="toItemFn(item)" class="card-item" v-for="(item, i) in page.row2" :key="i">
                <div class="card-img">
                  <img 
                    :src="`${$baseUrl}/evaluation/api/attachment/preview/${item.coverImageId}`"
                    alt
                    loading="lazy"
                  />
                </div>
                <div class="card-content">
                  <div class="title-line"></div>
                  <h4 class="card-title">{{ item.title }}</h4>
                  <p class="card-desc">{{ item.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="custom-arrow right" @click="toNext">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { publishedPage } from '@/api/account';
export default {
  name: "ProfessionalField",
  data() {
    return {
      cardList: [],
    };
  },
  computed: {
    pageList() {
      let list = [];
      const pageSize = 8;
      let limitList = this.cardList;
      for (let i = 0; i < limitList.length; i += pageSize) {
        let page = limitList.slice(i, i + pageSize);
        list.push({
          row1: page.slice(0, 4),
          row2: page.slice(4, 8),
        });
      }
      return list;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    toPrev() {
      this.$refs.carousel.prev();
    },
    toItemFn(item){
        this.$router.push({
          path:'/index/notification/deils',
          query:{
            id:item.notifyId,
          }
        })
    },
    toNext() {
      this.$refs.carousel.next();
    },
    getList() {
      publishedPage({
        typeCode: 3,
        pageSize: 10000000,
        pageNumber: 1,
      }).then((res) => {
        if (res.code == 200) {
          let list = res.data?.pageRecords || [];
          this.cardList = list.map(item => {
            return {
              ...item,
              content: this.extractText(item.content)
            };
          });
        }
      })
    },
    extractText(html) {
      if (!html) return '';
      let text = html.replace(/<img[^>]*>/g, '');
      text = text.replace(/<[^>]+>/g, '');
      text = text.replace(/\\["nrt]/g, '');
      text = text.trim().replace(/\s+/g, ' ');
      return text;
    },
  },
};
</script>

<style lang="less" scoped>
.professional-field {
  width: 100%;
  padding: 40px 20px;
  background: url('~@/assets/images/xw1.png');
  background-size: cover;
  background-position: center;
  background-attachment: scroll;
  font-family: "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}
.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
}
.section-title .line {
  width: 80px;
  height: 2px;
  background: #fff;
}
.section-title h2 {
  font-size: 32px;
  color: #fff;
  margin: 0 20px;
}
.swiper-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}
.custom-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 99;
}
.custom-arrow.left { left: -60px; }
.custom-arrow.right { right: -60px; }

.card-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: flex-start;
}

.card-item {
  width: 285px;
  height: 362px;
  flex: 0 0 calc(25% - 15px);
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
  transform: translateZ(0);
  backface-visibility: hidden;
  cursor: pointer;
}

.card-img {
  width: 100%;
  height: 180px;
  overflow: hidden;
}
.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  transform: translateZ(0);
}
.card-item:hover .card-img img {
  transform: scale(1.05);
}
.card-content {
  padding: 20px;
}
.title-line {
  width: 20px;
  height: 2px;
  background: #0066cc;
  margin-bottom: 10px;
  transition: width 0.3s ease;
}
.card-item:hover .title-line {
  width: 60px;
}
.card-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px;
}
.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/deep/ .el-carousel__container {
 
  transition: transform 0.4s ease !important;
}
/deep/ .el-carousel__arrow {
  display: none !important;
}

@media (max-width: 768px) {
  .custom-arrow { display: none; }
  .card-item {
    flex: 0 0 100% !important;
  }
  .section-title h2 { font-size: 24px; }
}
</style>